import { useEffect } from "react";
import { StrategiesCard } from "./card";
import { StrategiesNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { StrategiesTable } from "./table";

export default function Strategies() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Stratégies");
  }, []);

  return (
    <Routes>
      <Route index element={<StrategiesTable />} />
      <Route path="/new" element={<StrategiesNew />} />
      <Route path=":id" element={<StrategiesCard />} />
    </Routes>
  );
}
